// Generated from the repo-root package.json by scripts/gen-version.js — do not edit by hand.
export const APP_VERSION = '1.4.52';
